import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ContainerModule } from '../../container/container.module'
import { FilterSetModule } from '../../filter-set/filter-set.module'
import { SearchFiltersModule } from '../../search-filters/search-filters.module'
import { FilterableContainerComponent } from './filterable-container.component'
import { ToggleModule } from '../../toggle/toggle.module'
import { TabsSearchSetModule } from '../../tabs-search-set/tabs-search-set.module'
import { FloCssClassSanitizePipeModule } from '../../_pipes/css-class-sanitize/css-class-sanitize.pipe.module'
import { DecoratedTextCellModule } from '../../decorated-text-cell/decorated-text-cell.module'
import { FloTypeGuardModule } from 'src/app/shared/pipes/flo-type-guard-pipe.module'
import { SharedModule } from '../../../shared/shared.module'
import { EventListControlsModule } from '../../events/components/event-list-controls/event-list-controls.module'

@NgModule({
  imports: [
    CommonModule,
    ContainerModule,
    FilterSetModule,
    SearchFiltersModule,
    ToggleModule,
    TabsSearchSetModule,
    FloCssClassSanitizePipeModule,
    DecoratedTextCellModule,
    FloTypeGuardModule,
    SharedModule,
    EventListControlsModule
  ],
  declarations: [FilterableContainerComponent],
  exports: [FilterableContainerComponent]
})
export class FilterableContainerModule {}
